(function () {
  // The carousel's built-in thumbnail rail (slideshow-controls) is a web component
  // that manages its own sizing/scrolling — repeated attempts to reposition it via
  // CSS on mobile broke in ways that were hard to predict without live testing.
  // This builds a separate, plain vertical thumbnail strip instead, hidden from the
  // carousel's own layout entirely. Clicking a custom thumbnail proxies a real
  // .click() to the matching (hidden, still functional) native thumbnail button, so
  // slide-switching still runs through the theme's own tested code — this only
  // replaces how the thumbnails are drawn, not how selecting one works.
  function build() {
    var gallery = document.querySelector('[id$="__main"] media-gallery');
    if (!gallery) return;

    var container = gallery.closest('product-component');
    if (!container) return;
    if (container.querySelector('.aviiro-mobile-thumbs')) return;

    var nativeThumbs = gallery.querySelectorAll('.slideshow-controls__thumbnail');
    if (nativeThumbs.length < 2) return;

    var rail = document.createElement('div');
    rail.className = 'aviiro-mobile-thumbs';

    var railButtons = [];

    nativeThumbs.forEach(function (nativeButton) {
      var nativeImg = nativeButton.querySelector('img');
      if (!nativeImg) return;

      var button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('aria-label', nativeButton.getAttribute('aria-label') || '');
      if (nativeButton.getAttribute('aria-selected') === 'true') {
        button.classList.add('is-active');
      }

      var img = document.createElement('img');
      img.src = nativeImg.src;
      img.alt = nativeImg.alt || '';
      img.loading = 'lazy';
      button.appendChild(img);

      button.addEventListener('click', function () {
        nativeButton.click();
        railButtons.forEach(function (b) {
          b.classList.remove('is-active');
        });
        button.classList.add('is-active');
      });

      railButtons.push(button);
      rail.appendChild(button);
    });

    container.appendChild(rail);

    // The rail is positioned absolute against `container` (the nearest positioned
    // ancestor), which also wraps the buy-box content below the image — so without
    // this, top/bottom:0 would stretch it down past the image into that content.
    // Pin it to the gallery's own rendered box instead, kept in sync on resize.
    function syncRailToGallery() {
      var containerRect = container.getBoundingClientRect();
      var galleryRect = gallery.getBoundingClientRect();
      rail.style.top = galleryRect.top - containerRect.top + 8 + 'px';
      rail.style.height = galleryRect.height - 16 + 'px';
    }

    syncRailToGallery();
    window.addEventListener('resize', syncRailToGallery);
  }

  // The zoom dialog has its own native thumbnail strip, separate from the one
  // above — its images never actually render (almost certainly never fetched:
  // loading="lazy" combined with sitting inside a closed <dialog>, which browsers
  // don't treat as "on screen" for lazy-load purposes, even once CSS forces it
  // visible), while the buttons themselves work fine (clicking one does switch
  // the photo). Same fix as above: build a plain replacement from scratch, using
  // image URLs already loaded elsewhere on the page, and proxy clicks to the real
  // (invisible but functional) dialog buttons. Inserted as a child of the actual
  // <dialog> element itself, since browsers render dialog content in the top
  // layer — a sibling or ancestor-positioned element can't paint above that, only
  // a genuine descendant of the dialog can.
  function buildDialogRail() {
    var dialog = document.querySelector('[id$="__main"] .dialog-zoomed-gallery__dialog');
    if (!dialog) return;
    if (dialog.querySelector('.aviiro-dialog-thumbs')) return;

    var nativeThumbs = document.querySelectorAll('[id$="__main"] .slideshow-controls__thumbnail');
    var dialogButtons = dialog.querySelectorAll('.dialog-thumbnails-list__thumbnail');
    if (nativeThumbs.length < 2 || nativeThumbs.length !== dialogButtons.length) return;

    var rail = document.createElement('div');
    rail.className = 'aviiro-dialog-thumbs';

    var railButtons = [];

    nativeThumbs.forEach(function (nativeButton, index) {
      var nativeImg = nativeButton.querySelector('img');
      var dialogButton = dialogButtons[index];
      if (!nativeImg || !dialogButton) return;

      var button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('aria-label', nativeButton.getAttribute('aria-label') || '');
      if (dialogButton.getAttribute('aria-selected') === 'true') {
        button.classList.add('is-active');
      }

      var img = document.createElement('img');
      img.src = nativeImg.src;
      img.alt = nativeImg.alt || '';
      button.appendChild(img);

      button.addEventListener('click', function () {
        dialogButton.click();
        railButtons.forEach(function (b) {
          b.classList.remove('is-active');
        });
        button.classList.add('is-active');
      });

      railButtons.push(button);
      rail.appendChild(button);
    });

    dialog.appendChild(rail);
  }

  function init() {
    build();
    buildDialogRail();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
